import React, { Component } from 'react'
import LocationtoolSvgMap from './locationtoolSvgMap';

class locationtoolStage extends Component {
  constructor (props) {
    super(props);
    this.state = { isSelectOpen: false };
  }

  handleClick (e) {
    e.preventDefault()
    this.setState(state => ({
      isSelectOpen: !state.isSelectOpen
    }));
  }

  render () {
    return (
      <div className="mod-contact-stage">
        <div className="mod-contact-stage__content">
          <div className="mod-contact-stage__image">
            <LocationtoolSvgMap />
          </div>
        </div>
        <div className="mod-contact-stage__switcher">
          <div className="mod-contact-stage__headline">
            <h1>Zurich Contacts</h1>
          </div>
          <div className="mod-contact-stage__switcher-content">
            <p>
              For customer/company support, claims or products please select your
              country from the dropdown.
            </p>
          </div>
          <form>
            <fieldset className="form-group">

              <label htmlFor="custom-dropdown" className="sr-only">Select your country</label>
              <div className="js-Dropdown" id="custom-custom-dropdown">
                <button className="js-Dropdown-title flag flag--global" onClick={(e => this.handleClick(e))}>Zurich Global</button>
                <ul className={this.state.isSelectOpen ? 'js-Dropdown-list is-open' : 'js-Dropdown-list'}>
                  <li data-value="global" data-index="0" className="flag flag--global is-selected">Zurich Global</li>
                  <li data-value="ar" data-index="1" className="flag flag--ar">Argentina</li>
                  <li data-value="au" data-index="2" className="flag flag--au">Australia</li>
                  <li data-value="at" data-index="3" className="flag flag--at">Austria</li>
                  <li data-value="bh" data-index="4" className="flag flag--bh">Kingdom of Bahrain</li>
                  <li data-value="be" data-index="5" className="flag flag--be">Belgium</li>
                  <li data-value="br" data-index="6" className="flag flag--br">Brazil</li>
                  <li data-value="ca" data-index="7" className="flag flag--ca">Canada</li>
                  <li data-value="cl" data-index="8" className="flag flag--cl">Chile</li>
                  <li data-value="cn" data-index="9" className="flag flag--cn">China</li>
                  <li data-value="co" data-index="10" className="flag flag--co">Colombia</li>
                  <li data-value="dk" data-index="10" className="flag flag--dk">Denmark</li>
                  <li data-value="ec" data-index="11" className="flag flag--ec">Ecuador</li>
                  <li data-value="fi" data-index="12" className="flag flag--fi">Finland</li>
                  <li data-value="fr" data-index="13" className="flag flag--fr">France</li>
                  <li data-value="de" data-index="14" className="flag flag--de">Germany</li>
                  <li data-value="hk" data-index="15" className="flag flag--hk">Hong Kong</li>
                  <li data-value="id" data-index="16" className="flag flag--id">Indonesia</li>
                  <li data-value="ie" data-index="17" className="flag flag--ie">Ireland</li>
                  <li data-value="it" data-index="18" className="flag flag--it">Italy</li>
                  <li data-value="jp" data-index="19" className="flag flag--jp">Japan</li>
                  <li data-value="kw" data-index="20" className="flag flag--kw">Kuwait</li>
                  <li data-value="lb" data-index="21" className="flag flag--lb">Lebanon</li>
                  <li data-value="li" data-index="22" className="flag flag--li">Liechtenstein</li>
                  <li data-value="lu" data-index="23" className="flag flag--lu">Luxembourg</li>
                  <li data-value="my" data-index="24" className="flag flag--my">Malaysia</li>
                  <li data-value="mx" data-index="25" className="flag flag--mx">Mexico</li>
                  <li data-value="nl" data-index="26" className="flag flag--nl">Netherlands</li>
                  <li data-value="nz" data-index="27" className="flag flag--nz">New Zealand</li>
                  <li data-value="no" data-index="28" className="flag flag--no">Norway</li>
                  <li data-value="om" data-index="29" className="flag flag--om">Oman</li>
                  <li data-value="pt" data-index="30" className="flag flag--pt">Portugal</li>
                  <li data-value="qa" data-index="31" className="flag flag--qa">Qatar</li>
                  <li data-value="ru" data-index="32" className="flag flag--ru">Russia</li>
                  <li data-value="sg" data-index="33" className="flag flag--sg">Singapore</li>
                  <li data-value="sk" data-index="34" className="flag flag--sk">Slovakia</li>
                  <li data-value="es" data-index="35" className="flag flag--es">Spain</li>
                  <li data-value="se" data-index="36" className="flag flag--se">Sweden</li>
                  <li data-value="ch" data-index="37" className="flag flag--ch">Switzerland</li>
                  <li data-value="tw" data-index="38" className="flag flag--tw">Taiwan</li>
                  <li data-value="tr" data-index="39" className="flag flag--tr">Turkey</li>
                  <li data-value="gb" data-index="40" className="flag flag--gb">United Kingdom</li>
                  <li data-value="ae" data-index="41" className="flag flag--ae">United Arab Emirates</li>
                  <li data-value="us" data-index="42" className="flag flag--us">United States</li>
                </ul>
              </div>

              <select id="custom-dropdown" className="custom-select" name="country" style={{ display: 'none' }}>
                <option value="global" className="flag flag--global">Zurich Global</option>
                <option value="ar" className="flag flag--ar">Argentina</option>
                <option value="au" className="flag flag--au">Australia</option>
                <option value="at" className="flag flag--at">Austria</option>
                <option value="bh" className="flag flag--bh">Kingdom of Bahrain</option>
                <option value="be" className="flag flag--be">Belgium</option>
                <option value="br" className="flag flag--br">Brazil</option>
                <option value="ca" className="flag flag--ca">Canada</option>
                <option value="cl" className="flag flag--cl">Chile</option>
                <option value="cn" className="flag flag--cn">China</option>
                <option value="co" className="flag flag--co">Colombia</option>
                <option value="ec" className="flag flag--ec">Ecuador</option>
                <option value="fi" className="flag flag--fi">Finland</option>
                <option value="fr" className="flag flag--fr">France</option>
                <option value="de" className="flag flag--de">Germany</option>
                <option value="hk" className="flag flag--hk">Hong Kong</option>
                <option value="id" className="flag flag--id">Indonesia</option>
                <option value="ie" className="flag flag--ie">Ireland</option>
                <option value="it" className="flag flag--it">Italy</option>
                <option value="jp" className="flag flag--jp">Japan</option>
                <option value="kw" className="flag flag--kw">Kuwait</option>
                <option value="lb" className="flag flag--lb">Lebanon</option>
                <option value="li" className="flag flag--li">Liechtenstein</option>
                <option value="lu" className="flag flag--lu">Luxembourg</option>
                <option value="my" className="flag flag--my">Malaysia</option>
                <option value="mx" className="flag flag--mx">Mexico</option>
                <option value="nl" className="flag flag--nl">Netherlands</option>
                <option value="nz" className="flag flag--nz">New Zealand</option>
                <option value="no" className="flag flag--no">Norway</option>
                <option value="om" className="flag flag--om">Oman</option>
                <option value="pt" className="flag flag--pt">Portugal</option>
                <option value="qa" className="flag flag--qa">Qatar</option>
                <option value="ru" className="flag flag--ru">Russia</option>
                <option value="sg" className="flag flag--sg">Singapore</option>
                <option value="sk" className="flag flag--sk">Slovakia</option>
                <option value="es" className="flag flag--es">Spain</option>
                <option value="se" className="flag flag--se">Sweden</option>
                <option value="ch" className="flag flag--ch">Switzerland</option>
                <option value="tw" className="flag flag--tw">Taiwan</option>
                <option value="tr" className="flag flag--tr">Turkey</option>
                <option value="gb" className="flag flag--gb">United Kingdom</option>
                <option value="ae" className="flag flag--ae">United Arab Emirates</option>
                <option value="us" className="flag flag--us">United States</option>
              </select>
            </fieldset>
          </form>
        </div>
      </div>
    )
  }
}

export default locationtoolStage



// WEBPACK FOOTER //
// ./catalog/locationtool/locationtoolStage.js